/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Daily User Visit
 */
export const createDailyUserVisit = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/daily_user_visits`, method: 'POST', signal
    },
      );
    }




export const getCreateDailyUserVisitMutationKey = () => ['createDailyUserVisit'] as const;

export const getCreateDailyUserVisitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext> => {

const mutationKey = getCreateDailyUserVisitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDailyUserVisit>>, void> = () => {


          return  createDailyUserVisit()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDailyUserVisitMutationResult = NonNullable<Awaited<ReturnType<typeof createDailyUserVisit>>>

    export type CreateDailyUserVisitMutationError = ErrorType<void>


    /**
 * @summary Create Daily User Visit
 */
export const useCreateDailyUserVisit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDailyUserVisit>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateDailyUserVisitMutationOptions(options), queryClient);
    }
